module.exports = __webpack_public_path__ + "img/hamburger.f3b9254d.svg";